module.exports = function (isMobile, locale) {
  return {
    navList: [{
      name: 'Kit solaire pour balcon',
      imgSrc: isMobile ? ['solutions_nav_stream_h5.webp', 'solutions_nav_stream_h5.jpg'] : ['solutions_nav_stream.webp', 'solutions_nav_stream.jpg'],
      detLink: "/".concat(locale, "/powerstream"),
      tag: 'New'
    }, {
      name: 'Kits Énergie',
      imgSrc: isMobile ? ['solutions_nav_mm100_h5.webp', 'solutions_nav_mm100_h5.jpg'] : ['solutions_nav_mm100.webp', 'solutions_nav_mm100.jpg'],
      detLink: "/".concat(locale, "/ecoflow-power-kits/series")
    }
    // {
    //     name: 'Composants',
    //     icons: '',
    //     detLink: `https://${locale}.ecoflow.com/collections/power-kits-components`,
    // },
    // {
    //     name: 'Calculateur énergétique',
    //     icons: '',
    //     detLink: `/${locale}/calculators/power-kits`,
    //     target: '_blank',
    // },
    ],

    content: {
      headerData: [{
        type: 'large',
        name: 'Qu’est-ce que le kit solaire pour balcon PowerStream ?',
        desc: 'De l’énergie, de jour comme de nuit. Des économies intelligentes.',
        imgSrc: isMobile ? ['stream_bg_h5.webp', 'stream_bg_h5.jpg'] : ['stream_bg.webp', 'stream_bg.jpg'],
        detLink: "/".concat(locale, "/powerstream")
      }, {
        type: 'large',
        name: 'Que sont les Kits Énergie ?',
        desc: 'Simples. Intelligents. Compacts.',
        imgSrc: isMobile ? ['solutions_bg_h5.webp', 'solutions_bg_h5.jpg'] : ['solutions_bg.webp', 'solutions_bg.jpg'],
        detLink: "/".concat(locale, "/ecoflow-power-kits/series")
      }],
      contextList: [{
        type: 'small',
        name: 'Power Hub',
        desc: "Block d'entrée et sortie 5 en 1",
        imgSrc: isMobile ? ['solutions_list1_h5.webp', 'solutions_list1_h5.jpg'] : ['solutions_list1.webp', 'solutions_list1.jpg'],
        imgHoverSrc: ['solutions_list1_hover.webp', 'solutions_list1_hover.jpg'],
        detLink: "https://".concat(locale, ".ecoflow.com/products/power-hub")
      }, {
        type: 'small',
        name: 'Batteries LFP',
        desc: 'Capacités de stockage de 2 à 15 kWh',
        imgSrc: isMobile ? ['solutions_list2_h5.webp', 'solutions_list2_h5.jpg'] : ['solutions_list2.webp', 'solutions_list2.jpg'],
        imgHoverSrc: ['solutions_list2_hover.webp', 'solutions_list2_hover.jpg'],
        detLink: "https://".concat(locale, ".ecoflow.com/products/lfp-battery")
      }, {
        type: 'small',
        name: 'Panneau de distribution intelligent CA/CC',
        desc: '6+12 circuits AC/DC pour vos appareils',
        imgSrc: isMobile ? ['solutions_list3_h5.webp', 'solutions_list3_h5.jpg'] : ['solutions_list3.webp', 'solutions_list3.jpg'],
        imgHoverSrc: ['solutions_list3_hover.webp', 'solutions_list3_hover.jpg'],
        detLink: "https://".concat(locale, ".ecoflow.com/products/ac-dc-smart-distribution-panel")
      }, {
        type: 'small',
        name: 'Console pour Kits Énergie',
        desc: 'Montez, surveillez et contrôlez',
        imgSrc: isMobile ? ['solutions_list4_h5.webp', 'solutions_list4_h5.jpg'] : ['solutions_list4.webp', 'solutions_list4.jpg'],
        imgHoverSrc: ['solutions_list4_hover.webp', 'solutions_list4_hover.jpg'],
        detLink: "https://".concat(locale, ".ecoflow.com/products/power-kits-console")
      }]
    }
  };
};